// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"Q_c2"};